import services from 'services/services';
import * as types from '../types';

// Import helpers
import { checkFetchErrors } from '../helpers_actions/convert_helpers';

// ******************** FETCH VOD ENCODING ********************
export const fetchVodEncoding = (uuid) => async (dispatch) => {
	try {
		dispatch({
			type: types.FETCH_VOD_ENCODING_LOADING,
			payload: true
		});

		const { data } = await services.get(`/ingester/${uuid}/details?`);

		dispatch({
			type: types.FETCH_VOD_ENCODING_SUCCESS,
			payload: data
		});
	} catch (error) {
		dispatch({
			type: types.FETCH_VOD_ENCODING_ERROR,
			payload: checkFetchErrors(error)
		});
	}
};
